var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import createClient from "openapi-fetch";
export class IdpClient {
    constructor(getToken, baseUrl) {
        this.client = createClient({ baseUrl });
        this.token = getToken || null;
        this.baseUrl = baseUrl || window.location.origin;
    }
    buildAuthHeader() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.token) {
                return { Authorization: `Bearer ${yield this.token()}` };
            }
            return {};
        });
    }
    // This route serves both "svc/idp/code-exchange" & "/auth" in sj_frontend
    codeExchange(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.client.POST("/svc/idp/code-exchange", {
                body: options,
                headers: yield this.buildAuthHeader(),
            });
            return { data, error };
        });
    }
    // This route serves both "svc/idp/redirect-url" & "/auth/v2/domain"
    // Eventually we should remove the later route ("/auth/v2/domain") -- SHRPA-474
    redirect(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.client.POST("/svc/idp/redirect-url", {
                body: options,
            });
            return { data, error };
        });
    }
    confirmEmail(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.client.POST("/svc/idp/confirm-email", {
                body: options,
                headers: yield this.buildAuthHeader(),
            });
            return { data, error };
        });
    }
    getDomainForRedirectLogin(domain) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.client.GET("/svc/idp/domain/login-redirect", {
                params: { query: { domain } },
                headers: yield this.buildAuthHeader(),
            });
            return { data, error };
        });
    }
    updateDomainForRedirectLogin(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.client.POST("/svc/idp/domain/login-redirect", {
                body: options,
                headers: yield this.buildAuthHeader(),
            });
            return { data, error };
        });
    }
    getDomainListForRedirectLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.client.GET("/svc/idp/domain/login-redirects", {
                headers: yield this.buildAuthHeader(),
            });
            return { data: data || { domains: [] }, error };
        });
    }
    getIdpList() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.client.GET("/svc/idp/list", {
                headers: yield this.buildAuthHeader(),
            });
            return { data: data || { idps: [] }, error };
        });
    }
    getTenantIdp(tenantName) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.client.GET("/svc/idp/tenant", {
                params: { query: { tenantName } },
                headers: yield this.buildAuthHeader(),
            });
            return { data: data || { idp: {} }, error };
        });
    }
    updateTenantIdp(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.client.PATCH("/svc/idp/tenant", {
                body: options,
                headers: yield this.buildAuthHeader(),
            });
            return { data: data || { idp: {} }, error };
        });
    }
    deleteDomainForRedirectLogin(domain) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.client.DELETE("/svc/idp/domain/login-redirect", {
                params: { query: { domain } },
                headers: yield this.buildAuthHeader(),
            });
            return { data, error };
        });
    }
    getTenantIdpSettings(tenant, idpUuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.client.GET("/svc/idp/tenant/settings", {
                params: { query: { tenant, idpUuid } },
                headers: yield this.buildAuthHeader(),
            });
            return { data, error };
        });
    }
    updateTenantSettings(tenantIdpSettings) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.client.PUT("/svc/idp/tenant/settings", {
                body: tenantIdpSettings,
                headers: yield this.buildAuthHeader(),
            });
            return { data, error };
        });
    }
    createTenantIDP(tenantIdp) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.client.POST("/svc/idp/tenant", {
                body: tenantIdp,
                headers: yield this.buildAuthHeader(),
            });
            return { data, error };
        });
    }
    generateAuthNonce() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.client.POST("/svc/idp/auth/nonce", {
                body: {},
            });
            return { data, error };
        });
    }
    passwordAuthenticate(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error, response: { status }, } = yield this.client.POST("/svc/idp/auth/password", {
                body: options,
            });
            return { data, error, status };
        });
    }
    authenticateWithCode(options) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const { error } = yield this.client.GET("/svc/idp/auth/exchange", {
                params: {
                    query: {
                        code: options.code,
                        state: (_a = options.state) !== null && _a !== void 0 ? _a : undefined,
                        redirect_url: (_b = options.redirect_url) !== null && _b !== void 0 ? _b : undefined,
                    },
                },
                credentials: "include",
            });
            return { error };
        });
    }
    refreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const { error } = yield this.client.POST("/svc/idp/auth/refresh", {
                body: {},
                credentials: "include",
            });
            return { error };
        });
    }
    signOut() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.POST("/svc/idp/auth/signout", {
                credentials: "include",
            });
            return { response: response.response, error: response.error };
        });
    }
}
//# sourceMappingURL=idp.js.map